import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Form, Input, message, Spin } from 'antd';
import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';
import { POOL_DATA, USERNAME_URL } from "../../../utils/config";
import { Helmet } from "react-helmet";

import GetStarted from '../GetStarted';
import Newpwd from './Newpwd';
import './Forgot.css';

class Forgot extends Component {

  state={
    visible: false,
    userName: '',
    errMsg: '',
    loading: false,
  };

  componentWillMount() {
    const userPool = new CognitoUserPool(POOL_DATA);

    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return;
        }
        if (session.isValid() === true) {
          this.props.history.push('/profile');
        }
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      errMsg: '',
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        const userPool = new CognitoUserPool(POOL_DATA);

        const userData = {
          Username : values.username,
          Pool : userPool
        };

        const cognitoUser = new CognitoUser(userData);
        cognitoUser.forgotPassword({
          onSuccess: (result) => {
            this.setState({
              userName: values.username,
              visible: true,
              loading: false,
            })
          },
          onFailure: (err) => {
            if (String(err).indexOf('combination') !== -1) {
              const userNameUrl = `${USERNAME_URL}?email=${values.username}`;
              fetch(userNameUrl, {
                method: 'GET'
              })
                .then(res => res.json())
                .then((data) => {
                  const userData = {
                    Username : data.generatedUserName,
                    Pool : userPool,
                  };

                  const cognitoUser = new CognitoUser(userData);

                  cognitoUser.forgotPassword( {
                    onSuccess: () => {
                      this.setState({
                        userName: values.username,
                        visible: true,
                        loading: false,
                      })
                    },
                    onFailure: (err) => {
                      if (String(err).indexOf('Cannot reset password for the user as there is no registered/verified email or phone_number') !== -1 ) {
                        this.setState({
                          errMsg: <span className="errMsg">It seems you haven't verify your email address. <a onClick={this.handleResend.bind(this, cognitoUser)}>Resend verification email</a></span>,
                        });
                      } else if (String(err).indexOf('Username/client id combination not found.') !== -1 ) {
                        this.setState({
                          errMsg: <span className="errMsg">It seems you haven't registered yet. <Link to="/register">Sign up</Link>.</span>,
                        });
                      } else {
                        this.setState({
                          errMsg: <span className="errMsg">{String(err).split(': ')[1]}</span>,
                        });
                      }
                    }
                  });
                });
            } else {
              message.error(String(err).split(': ')[1]);
            }
            this.setState({
              loading: false,
            });
          }
        });
      }
    });
  };

  setVisible = () => {
    this.setState({
      visible: false,
    });
  };

  handleResend = (cognitoUser) => {
    this.setState({
      loading: true,
    });
    cognitoUser.resendConfirmationCode((err) => {
      if (err) {
        message.error(String(err).split(': ')[1]);
        return;
      }
      message.success('An email contains verification link has been sent to your registered email address');
      this.setState({
        loading: false,
        errMsg: <span className="errMsg">Did not receive? <a onClick={this.handleResend.bind(this, cognitoUser)}>Resend</a></span>,
      });
    });
  };

  checkEmail = (rule, value, callback) => {
    const form = this.props.form;
    if (/[A-Z]/.test(form.getFieldValue('username'))) {
      callback('Email must be lowercase');
    } else {
      callback();
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="Forgot">
        <Helmet>
          <title>Forgot Password - Qbates</title>
          <meta name="description" content="Forgot your password? Find back." />
        </Helmet>
        <GetStarted/>
        <h3>Forgot Password</h3>
        <Newpwd visible={this.state.visible} userName={this.state.userName} setVisible={this.setVisible.bind(this)}/>
        <Spin spinning={this.state.loading}>
        <Form
          onSubmit={this.handleSubmit}
          onChange={this.handleChange}
          className="forgot-form"
        >
          <Form.Item hasFeedback>
            <span>Email</span>
            {getFieldDecorator('username', {
              rules: [
                { type: 'email', message: 'The input is not valid E-mail' },
                { validator: this.checkEmail },
                { required: true, message: 'Please input your Email' }],
            })(
              <Input type="text" placeholder="Email"/>
            )}
            {this.state.errMsg}
          </Form.Item>
          <Form.Item className="forgot-button">
            <button>SENT CODE</button>
          </Form.Item>
        </Form>
        </Spin>
      </div>
    );
  }
}

const WrappedForgot = Form.create()(Forgot);
export default withRouter(WrappedForgot);


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Forgot.js